<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入关键字进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
<!--                    <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button> -->
                </div>
                <div>

                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加推广商
                    </el-button>
                </div>
            </div>
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row style="margin-top: 10px">
                        <el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">用户联系人：</div>
								<div>
									<el-input placeholder="请输入用户联系人" size="medium" v-model="searchValue.ktiContacts"></el-input>
								</div>
							</div>
                        </el-col>
						<el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">联系方式：</div>
								<div>
									<el-input placeholder="请输入用户联系人方式" size="medium" v-model="searchValue.ktiContactWay"></el-input>
								</div>
							</div>
						</el-col>
                        <el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">用户状态：</div>
								<div>
									<el-radio-group v-model="searchValue.ktiIsEnable">
										<el-radio :label="0">启用</el-radio>
										<el-radio :label="1">停用</el-radio>
									</el-radio-group>
								</div>
							</div>
                        </el-col>
                        <el-col :span="6" >
							<div class="txt_align_right advance_btn_warp">
								<el-button size="mini" icon="el-icon-search" type="primary" @click="initEmps('advanced')">搜索</el-button>
							</div>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->

                <el-table-column
                        prop="kqbaId"
                        align="center"
                        label="令牌"
                        min-width="35%">
                </el-table-column>

                <el-table-column
                        prop="kqbaName"
                        align="center"
                        label="推广商"
                        min-width="15%">
                </el-table-column>

            
				<el-table-column
				        prop="kqbaIsDelete"
						label="状态"
				        align="center"
				        min-width="15%">
					<template slot-scope="scope">
						<span>{{scope.row.kqbaIsDelete == '1' ? '启用' : '禁用'}}</span>
					</template>
				</el-table-column>
				<el-table-column
				        prop="qmList"
						label="权限"
				        align="center"
				        min-width="35%">
					<template slot-scope="scope">
						<span>{{scope.row.qmNameList}}</span>
					</template>
				</el-table-column>
                <el-table-column
                        fixed="right"
                        min-width="15%"
						align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini" v-if="currentHr.roles[0].roleId == '1001'">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger" v-if="currentHr.roles[0].roleId == '1001' ">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>

        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
				:before-close="handlePopClose"
                width="80%">
            <div class="pop_block_warp">
				<div class="block">
					<p>推广商基本信息</p>
					<el-form :model="emp" :rules="rules" ref="empForm">
					    <el-row>
					        <el-col >
					            <el-form-item label="推广商名称:" prop="kqbaName">
									<div class="input_box">
										<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.kqbaName"
										          placeholder="请输入推广商名称" maxlength="50" show-word-limit></el-input>
									</div>
					            </el-form-item>
					        </el-col>
						</el-row>
					    <el-row>
							<el-col >
							    <el-form-item label="推广商状态:" prop="kqbaIsDelete">
							        <el-radio-group v-model="emp.kqbaIsDelete">
							            <el-radio :label="1">启用</el-radio>
							            <el-radio :label="0">停用</el-radio>
							        </el-radio-group>
							    </el-form-item>
							</el-col>
					    </el-row>
					</el-form>
				</div>
                <div class="block">
					<p>辩证病种权限</p>
					<el-input
					  placeholder="输入关键字进行过滤"
					  v-model="filterQuestionModelText" style="width: 60%;">
					</el-input>
					<div class="treeWarp" style="height: 300px;overflow-y: scroll;width: 60%;">
						<el-tree :data="questionModels" show-checkbox node-key="kqmId" default-expand-all
							:expand-on-click-node="false" ref="questionModelsTree" :filter-node-method="filterQuestionModelNode">
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>{{ data.kqmName }}</span>
							</span>
						</el-tree>
					</div>
				</div>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="closePop">取 消</el-button>
				<el-button type="primary" @click="doAddEmp">确 定</el-button>
			  </span>
        </el-dialog>
    </div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';
	//所需页面导入
	import vue from 'vue'
	import QRCode from 'qrcodejs2'
    export default {
        name: "Tenants",
        data() {
            return {
				questionModels:[],
                searchValue: {
					ktiContacts:'',
					ktiContactWay:'',
					ktiIsEnable:''
                },
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
                loading: false,
                dialogVisible: false,
				qrcodeDialogVisible:false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
				tempTenantId:'',
                emp: {
					kqbaId:'',
					kqbaName:'',
					kqbaIsDelete:1,
					qmList:[]
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    kqbaName: [{required: true, message: '请输入推广商名称', trigger: 'blur'}],
					kqbaIsDelete: [{required: true, message: '请选择推广商状态', trigger: 'blur'}],
                },
				childRoles:[],
				filterQuestionModelText:''
            }
        },
		computed:{
			...mapState([
			      'currentHr' // 将 `this.count` 映射为 `store.state.count`
			]),
		},
		watch: {
			filterQuestionModelText(val){
				this.$refs.questionModelsTree.filter(val);
			}
		},
        mounted() {
            this.initEmps();
            this.initData();
			this.getQuestionModelListByRole()
        },
        methods: {
			async getQuestionModelListByRole(){
				this.getRequest('/tenant/basic/getQuestionModelListByRole').then(resp => {
				    if (resp) {
						console.log(resp)
						this.questionModels = JSON.parse(JSON.stringify(resp.obj))
				    }
				});
			},
			filterQuestionModelNode(value, data){
				console.log(value,data)
				if (!value) return true;
				return data.kqmName.indexOf(value) !== -1;
			},
			checkMenuTreeClick(checkedNodes, checked, node){
				console.log(checkedNodes)
				if (checked) {
					this.$refs.menusTree.setCheckedKeys([checkedNodes.id]);
				} else {
					this.$refs.menusTree.setCheckedKeys([]);
				}
			},
			handlePopClose(done){
				console.log("handlePopClose")
				this.emptyEmp();
				this.$nextTick(()=>{
					this.$refs.questionModelsTree.setCheckedKeys([]);
				})
				
				done();
			},
			closePop(){
				this.emptyEmp();
				this.filterQuestionModelText = ''
				this.$refs.questionModelsTree.setCheckedKeys([]);
				this.dialogVisible = false
			},
            emptyEmp() {
                this.emp = {
					kqbaId:'',
					kqbaName:'',
					kqbaIsDelete:1,
					qmList:[]
                }
                this.inputDepName = '';
				this.emp.qmList = []
				this.$nextTick(()=>{
					this.$refs.questionModelsTree.setCheckedKeys([]);
				})
            },
            showEditEmpView(data) {
				console.log(data)
				data.kqbaIsDelete = parseInt(data.kqbaIsDelete)
                this.title = '编辑推广商信息';
                this.emp = data;
                this.dialogVisible = true;
				this.$nextTick(()=>{
					this.$refs.questionModelsTree.setCheckedKeys(data.qmList);
				})
				
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.kqbaName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$confirm('此操作将永久删除【' + data.kqbaName + '】, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.deleteRequest("/qmAuthManager/basic/del/" + data.kqbaId).then(resp => {
                            if (resp) {
                                this.initEmps();
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddEmp() {
				console.log(this.emp)
                if (this.emp.kqbaId) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
							var menuCheckedKeys =  this.$refs.questionModelsTree.getCheckedKeys()
							console.log(menuCheckedKeys)
							if(menuCheckedKeys.length == 0){
								this.$message({
								    type: 'warning',
								    message: '请选择推广商病种权限'
								});
								return;
							}
							this.emp.qmList = menuCheckedKeys
                            this.postRequest("/qmAuthManager/basic/modifyQuesModelBuss", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
							var menuCheckedKeys =  this.$refs.questionModelsTree.getCheckedKeys()
							console.log(menuCheckedKeys)
							if(menuCheckedKeys.length == 0){
								this.$message({
								    type: 'warning',
								    message: '请选择推广商病种权限'
								});
								return;
							}
							this.emp.qmList = menuCheckedKeys
                            this.postRequest("/qmAuthManager/basic/addQuesModelBuss", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.emp.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
				
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加推广商';
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                let url = '/qmAuthManager/basic/getQuesModelBussListForPage?page=' + this.page + '&size=' + this.size;
                url += "&keyword=" + this.keyword;
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            },
			getUserRoleChildRoles(){
				this.getRequest('/userManager/basic/getUserRoleChildRoles').then(resp => {
				    if (resp.status == 200) {
						this.childRoles = resp.obj
				    }
				});
			}
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	.el-form-item {
		display: flex;
		.input_box {
			width: 14.5rem;
			.el-input {
				width: 100% !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
	.pop_block_warp {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		width: 100%;
		.block {
			width:50%;
			text-align: center;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			p {
				font-size: 16px;
				font-weight: 700;
				text-align: center;
			}
		}
		.block:first-child {
			border-right: 1px solid #eff2f6;
		}
	}
	::v-deep .el-dialog__footer {
		text-align: center;
	}
</style>
